export default __webpack_public_path__ + "static/media/bitlabs.43e98517.svg";